const NS = 'SiteHeaderMenuWidget';
const CLS = 'siteHeaderMenuWidget';

export class SiteHeaderMenuWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$siteHeaderWidget = $('[data-wg="SiteHeaderWidget"]');

		// this.$element.on('click', () => {
		// 	this.$element.trigger('siteHeaderMenuWidget.close', {});
		// });

		this.$element.find('a').on('click', (event) => {
			event.stopPropagation();
		});

		this.$element.on('siteHeaderMenuWidget.open', () => {
			this.$element.attr('data-active', true);
			this.setPosition();
			this.setHeight();
		});

		this.$element.on('siteHeaderMenuWidget.close', () => {
			this.$element.attr('data-active', false);
		});
	}

	setPosition() {
		this.$element.css({
			top: this.$siteHeaderWidget.offset().top + this.$siteHeaderWidget.height()
		});
	}

	setHeight() {
		this.$element.css({
			minHeight: `calc(100vh - ${this.$siteHeaderWidget.height()}px)`,
			maxHeight: `calc(100vh - ${this.$siteHeaderWidget.height()}px)`
		});
	}
}

